const FactBoxTypes = {
  SECTION: 'section',
  CONTACT: 'contact',
  TEASER: 'teaser',
  LEAD: 'lead',
};

module.exports = FactBoxTypes;
